/**
 * Returns an array that is the intersection of all the arrays.
 * Each value in the result is present in each of the arrays.
 * @param arrays - any number of arrays
 */
export const getIntersection = <T>(...arrays: T[][]): T[] => {
  return arrays.reduce((a, b) => a.filter((c) => b.includes(c)));
};
